export default __webpack_public_path__ + "static/media/printApprovalformIcon.8e194598.svg";